import { useTranslation } from 'react-i18next'

import { Dropdown, Trans } from '@/components'

import { AUTH_OPTION_LABEL_KEYS, AUTH_OPTIONS } from '../../constants'
import { AccessMode } from '../../types'

interface AccessMethodSectionProps {
  auth: string
  setAuth: (auth: string) => void
  accessMode: AccessMode
  setAccessMode: (mode: AccessMode) => void
}

// Manual mode (endpoint-level cards) only exists for Instance routes and is locked off
// while routes are MaaS-only; the endpoint card markup lives in git history.
export function AccessMethodSection({
  auth,
  setAuth,
  accessMode,
  setAccessMode,
}: AccessMethodSectionProps) {
  const { t } = useTranslation('modelRoute')

  return (
    <div className="flex flex-col gap-6">
      <span className="h6 pl-2 border-l-4 border-secondary">
        <Trans ns="modelRoute" i18nKey="create.accessMethod">
          Access Method
        </Trans>
      </span>

      <div className="flex flex-col gap-2 max-w-[600px]">
        <div className="t-sb text-primary">
          <Trans ns="modelRoute" i18nKey="create.accessAuth">
            Access Authentication
          </Trans>
        </div>
        <Dropdown
          rootClassName="t-sb"
          options={AUTH_OPTIONS.map((a) => ({
            label: AUTH_OPTION_LABEL_KEYS[a] ? t(AUTH_OPTION_LABEL_KEYS[a], a) : a,
            value: a,
            className: 't-sm',
          }))}
          value={auth}
          onChange={(value) => setAuth(String(value))}
        />
      </div>

      <div className="flex flex-col gap-2 max-w-[600px]">
        <div className="t-sb text-primary">
          <Trans ns="modelRoute" i18nKey="create.apiAccessMode">
            API Access Mode
          </Trans>
        </div>
        <Dropdown
          rootClassName="t-sb"
          options={[
            { label: t('create.modeAuto', 'Auto'), value: 'auto', className: 't-sm' },
            // TODO(model-route-api): Manual (endpoint-level) only exists for Instance
            // routes — locked to Auto until those launch
            {
              label: t('create.modeManual', 'Manual'),
              value: 'manual',
              className: 't-sm',
              disabled: true,
            },
          ]}
          value={accessMode}
          onChange={(value) => setAccessMode(value as AccessMode)}
        />
      </div>
    </div>
  )
}
